import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Lock, LogIn, ArrowLeft } from "lucide-react";
import { useAdmin } from "../contexts/AdminContext";

const AdminLogin = () => {
  const { authenticated, loading, login } = useAdmin();
  const navigate = useNavigate();
  const location = useLocation();
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!loading && authenticated) {
      const to = location.state?.from?.pathname || "/admin";
      navigate(to, { replace: true });
    }
  }, [authenticated, loading, navigate, location.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const { ok, error: err } = await login(password);
    setSubmitting(false);
    if (!ok) setError(err || "Contraseña incorrecta");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#F4F1EA",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 440,
          background: "#fff",
          borderRadius: 24,
          padding: 36,
          boxShadow: "0 30px 70px -25px rgba(26,19,82,0.25)",
          border: "1px solid rgba(26,19,82,0.08)",
        }}
      >
        <a href="/" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "#5F5A72", textDecoration: "none", fontSize: 13, marginBottom: 24 }}>
          <ArrowLeft size={14} /> Volver al sitio
        </a>
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 16,
            background: "linear-gradient(135deg,#5446EA,#C04ABF)",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            marginBottom: 18,
          }}
        >
          <Lock size={22} />
        </div>
        <h1 className="h-display" style={{ fontSize: 28, margin: "0 0 8px", color: "#1A1352" }}>
          Panel de Administración
        </h1>
        <p style={{ color: "#5F5A72", fontSize: 14, marginBottom: 24 }}>
          Ingresa tu contraseña para administrar vídeos y editar la página.
        </p>

        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: 13, fontWeight: 600, color: "#1A1352", display: "block", marginBottom: 6 }}>
            Contraseña
          </label>
          <input
            type="password"
            className="ae-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            autoFocus
            required
          />
          {error && <div style={{ color: "#E83E0A", fontSize: 13, marginTop: 10 }}>{error}</div>}
          <button
            type="submit"
            className="btn-orange"
            disabled={submitting}
            style={{ width: "100%", justifyContent: "center", marginTop: 18, opacity: submitting ? 0.7 : 1 }}
          >
            {submitting ? "Verificando…" : (
              <>
                Entrar <LogIn size={16} />
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
